var domain={
    change(code){
      var hostname = window.location.hostname;
      //切换站点 清空渠道缓存
      sessionStorage.removeItem('channel');

      hostname = hostname.substr(hostname.indexOf('.')+1,hostname.length);

      if(window.innerWidth<=768){
        window.open(window.location.protocol+'//m.'+hostname+'/'+ code, '_self');
      }else{
        window.open(window.location.protocol+'//'+code+'.'+hostname, '_self');
      }
      console.log(hostname)
    }
}
export default domain;


// WEBPACK FOOTER //
// ./src/store/domain.js